import digitalData from 'digital-data';
import {
  ATC,
  MAGIC_APRON,
  MAGIC_APRON_ASSISTANT_SUBMIT_CLICK_EVENT,
  MAGIC_APRON_BOT_SUBMIT_CLICK_EVENT,
  NOT_APPLICABLE,
  PRODUCT_POD,
  RECOMMENDATION_EVENTNAME,
  RECS_CART_ADDITION_INFO,
  SECTION,
  STASH,
} from '../constants';
import { pushAnalyticsEvent } from '../thd-analytics-utils';

export const magicApronBot = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-bot.submit-click', ({ output = {} }) => {
    const { sessionID = '', actionID = '', question = '' } = output;
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: MAGIC_APRON
      },
      eventInfo: {
        eventName: MAGIC_APRON_BOT_SUBMIT_CLICK_EVENT
      },
      maSessionID: sessionID,
      maActionID: actionID,
      question
    };
    pushAnalyticsEvent(thdAnalyticsEvent);
  });
};

export const magicApronAssistant = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-assistant.product-pod-click', ({ output = {} }) => {
    const { displayPosition = '' } = output;
    const pageType = digitalData?.page?.pageInfo.pageType;

    const thdAnalyticsEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: RECOMMENDATION_EVENTNAME
      },
      eventMode: STASH,
      stash: {
        recommendation: {
          anchorProductSku: 'n/a',
          displayPosition,
          featureVersion: 'n/a',
          interval: 'n/a',
          pageType,
          recommendationType: 'maa best-matches',
          // Set value to the "version" returned in API response.
          recommendationVersion: '',
          // Set value to the "version" returned in API response.
          strategy: ''
        }
      }
    };

    pushAnalyticsEvent(thdAnalyticsEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-assistant.product-pod-atc-click', ({ output = {} }) => {
    const { items = [] } = output;
    const pageType = digitalData?.page?.pageInfo.pageType;

    const thdAnalyticsEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: RECS_CART_ADDITION_INFO
      },
      eventMode: STASH,
      stash: {
        component: PRODUCT_POD,
        pageType,
        section: SECTION,
        sharedSection: NOT_APPLICABLE,
        target: ATC,
        item: items,
        recommendation: {
          recommendationType: 'maa best-matches',
          pageType,
          anchorProductSku: 'n/a',
          // Strategy value from dynamic recs API response (response will contain multiple strategy values,
          // choose the strategy value for the OMSID that was clicked on). If NOT available, set to "n/a"
          strategy: 'n/a',
          // Add version value from the API response. If not available, set to "n/a"
          recommendationVersion: 'n/a',
          featureVersion: 'n/a',
          interval: 'n/a',
          // For Sponsored Product = "sp", for non-SP = "n/a"
          sponsoredProduct: 'n/a'
        }
      }
    };

    pushAnalyticsEvent(thdAnalyticsEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-assistant.fab-click', ({ output = {} }) => {
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: 'magic apron'
      },
      eventInfo: {
        eventName: 'maa fab click'
      },
      maSessionID: output?.sessionID || '',
      maActionID: output?.actionID || ''
    };

    pushAnalyticsEvent(thdAnalyticsEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-assistant.submit-click', ({ output = {} }) => {
    const { sessionID = '', question = '', actionID = '' } = output;
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: MAGIC_APRON
      },
      eventInfo: {
        eventName: MAGIC_APRON_ASSISTANT_SUBMIT_CLICK_EVENT
      },
      maSessionID: sessionID,
      question,
      maActionID: actionID

    };
    pushAnalyticsEvent(thdAnalyticsEvent);
  });
};

// NOTE: might be changed to 'magic apron store' in the future
const MAGIC_APRON_STORE_PRIMARY_CATEGORY = 'magic cart';
const MAGIC_APRON_STORE_MA_PRIMARY_CATEGORY = 'magic apron';
const MAGIC_APRON_STORE_QUESTION_SUBMITTED_EVENTNAME = 'maa question submit';
const MAGIC_APRON_STORE_FEEDBACK_SUBMITTED_EVENTNAME = 'maa feedback click';
const MAGIC_APRON_STORE_SEARCH_EVENTNAME = 'search';
const MAGIC_APRON_STORE_ASK_ABOUT_PRODUCT_EVENTNAME = 'ask about this product';
const MAGIC_APRON_STORE_BUY_PRODUCT_ONLINE_EVENTNAME = 'buy it online';
const MAGIC_APRON_STORE_ASK_FOR_ASSOCIATE_FEEDBACK_EVENTNAME = 'ask for associate feedback';

export const magicApronStore = () => {

  // MCA 2.1 Product Image Upload / Voice Search
  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-store.search', ({ output = {} }) => {
    const { sessionID = '', actionID = '', searchType = '' } = output;
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: MAGIC_APRON_STORE_PRIMARY_CATEGORY
      },
      eventInfo: {
        eventName: MAGIC_APRON_STORE_SEARCH_EVENTNAME
      },
      maSessionID: sessionID,
      maActionID: actionID,
      macSearch: searchType
    };
    pushAnalyticsEvent(thdAnalyticsEvent);
  });

  // MCA 2.2 Questions Asked (On the Magic Cart Chat Drawer)
  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-store.question-submitted', ({ output = {} }) => {
    const { sessionID = '', actionID = '', question = '' } = output;
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: MAGIC_APRON_STORE_MA_PRIMARY_CATEGORY
      },
      eventInfo: {
        eventName: MAGIC_APRON_STORE_QUESTION_SUBMITTED_EVENTNAME
      },
      maSessionID: sessionID,
      maActionID: actionID,
      question
    };
    pushAnalyticsEvent(thdAnalyticsEvent);
  });

  // MCA 2.3 Feedback Submission
  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-store.feedback-submitted', ({ output = {} }) => {
    const { sessionID = '', actionID = '', question = '', feedback = '', searchType = '' } = output;
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: MAGIC_APRON_STORE_MA_PRIMARY_CATEGORY
      },
      eventInfo: {
        eventName: MAGIC_APRON_STORE_FEEDBACK_SUBMITTED_EVENTNAME
      },
      sessionID,
      actionID,
      feedback,
      question,
      macSearch: searchType
    };
    pushAnalyticsEvent(thdAnalyticsEvent);
  });

  // MCA 3.1 Ask About this Product
  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-store.ask-about-product-clicked', ({ output = {} }) => {
    const { sessionID = '', actionID = '' } = output;
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: MAGIC_APRON_STORE_PRIMARY_CATEGORY
      },
      eventInfo: {
        eventName: MAGIC_APRON_STORE_ASK_ABOUT_PRODUCT_EVENTNAME
      },
      maSessionID: sessionID,
      maActionID: actionID,
      question: 'mac:ask about this product'
    };
    pushAnalyticsEvent(thdAnalyticsEvent);
  });

  // MCA 4.1 Purchase Online / Buy it Online
  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-store.buy-product-online-clicked', ({ output = {} }) => {
    const { sessionID = '', actionID = '' } = output;
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: MAGIC_APRON_STORE_PRIMARY_CATEGORY
      },
      eventInfo: {
        eventName: MAGIC_APRON_STORE_BUY_PRODUCT_ONLINE_EVENTNAME
      },
      maSessionID: sessionID,
      maActionID: actionID,
      macOnline: 'mac:buy it online'
    };
    pushAnalyticsEvent(thdAnalyticsEvent);
  });

  // MCA 5.1 Ask for Associate Feedback
  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-store.ask-for-associate-feedback-submitted', ({ output = {} }) => {
    const { sessionID = '', actionID = '', feedback = '' } = output;
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: MAGIC_APRON_STORE_PRIMARY_CATEGORY
      },
      eventInfo: {
        eventName: MAGIC_APRON_STORE_ASK_FOR_ASSOCIATE_FEEDBACK_EVENTNAME
      },
      sessionID,
      actionID,
      feedback
    };
    pushAnalyticsEvent(thdAnalyticsEvent);
  });
};
